import { ApiWrapper, PagingResults } from '../../types';
import { FileSyncAdminSpot, FileSyncAdminSpotsProps, FileSyncFileBank, FileSyncUserQuota } from '../../types/fileSync';
import { OF } from '../../util';
import { JBaseApi } from '../base';

export class JFileSyncApi extends JBaseApi {
    public getFileBanks(signal?: AbortSignal): Promise<ApiWrapper<FileSyncFileBank[]>> {
        return this.network.post(
            {
                o: 'file-sync',
                f: 'getFileBanks',
            },
            signal,
        );
    }

    public saveFileBanks(fileBanks: FileSyncFileBank[]): Promise<ApiWrapper<boolean>> {
        return this.network.post({
            o: 'file-sync',
            f: 'saveFileBanks',
            fileBanks,
        } as OF);
    }

    public getUserQuota(signal?: AbortSignal): Promise<ApiWrapper<FileSyncUserQuota>> {
        return this.network.post(
            {
                o: 'file-sync',
                f: 'getUserQuota',
            } as OF,
            signal,
        );
    }

    public getAdminSpots(
        props: FileSyncAdminSpotsProps,
        signal?: AbortSignal,
    ): Promise<ApiWrapper<PagingResults<FileSyncAdminSpot>>> {
        return this.network.post<PagingResults<FileSyncAdminSpot>>(
            {
                o: 'objectList',
                f: 'fileSyncAdminSpots',
                ...props,
            } as OF,
            signal,
        );
    }
}
